import Vue from 'vue';
import Vuex from 'vuex';
import userStore from './user/userStore.js';
import VuexPersist from "vuex-persistedstate";
// import createPersistedState from 'vuex-persistedstate'
// import * as Cookies from 'js-cookie'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'


const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export default new Vuex.Store({
  modules: {
    userStore,
    plugins: [vuexLocalStorage.plugin]
  },

  state: {
    // role: [],
    dashbd_view: null,
    dashbd_rights: null,
    reg_view: null,
    reg_rights: null,
    shop_view: null,
    shop_rights: null,
    u_view: null,
    u_rights: null,
    r_view: null,
    r_rights: null,
    cust_view: null,
    cust_rights: null,
    sup_view: null,
    sup_rights: null,
    invt_view: null,
    invt_rights: null,
    stcktran_view: null,
    stcktran_rights: null,
    prod_view: null,
    prod_rights: null,
    cat_view: null,
    cat_rights: null,
    brand_view: null,
    brand_rights: null,
    tax_view: null,
    tax_rights: null,
    hsn_view: null,
    hsn_rights: null,
    var_view: null,
    var_rights: null,
    unit_view: null,
    unit_rights: null,
    pur_view: null,
    pur_rights: null,
    purrt_view: null,
    purrt_rights: null,
    sale_view: null,
    sale_rights: null,
    salert_view: null,
    salert_rights: null,
    salerechis_view: null,
    salerechis_rights: null,
    salereturnpay_view: null,
    salereturnpay_rights: null,
    purchasereturnpay_view: null,
    purchasereturnpay_rights: null,
    saleinvoice_view: null,
    saleinvoice_rights: null,
    salerec_view: null,
    salerec_rights: null,
    purpay_view: null,
    purpay_rights: null,
    purpayhis_view: null,
    purpayhis_rights: null,

    // Super User
    is_super_user: null,
    is_shop_user: null,
    shopmodal: null,
    custmodal: null,
    productmodal: null,
    supmodal: null,

    //Minsyst Admin
    is_admin: null,
  },

  getters: {
    // get_user_role: (state) => (pg) => {
    //    var r = state.role.find(r => r.page_name === 1)
    //    return r.view
    //  }
    // get_user_role(state){
    // return state.role.find(r => r.page_name === 1)
    // return dashboard_view[0].view
    // },

    get_is_admin(state) {
      // console.log(state.is_admin)
      return state.is_admin
    },

    get_shop_user(state) {
      return state.is_shop_user
    },

    get_super_user(state) {
      return state.is_super_user
    },

    get_dashbd_view(state) {
      return state.dashbd_view
      // return false
    },
    get_dashbd_rights(state) {
      // return false
      return state.dashbd_rights
    },
    get_reg_view(state) {
      return state.reg_view
      // return false
    },
    get_reg_rights(state) {
      // return false
      return state.reg_rights
    },
    get_shop_view(state) {
      return state.shop_view
      // return false
    },
    get_shop_rights(state) {
      // return false
      return state.shop_rights
    },
    get_u_view(state) {
      return state.u_view
      // return false
    },
    get_u_rights(state) {
      // return false
      return state.u_rights
    },
    get_r_view(state) {
      return state.r_view
      // return false
    },
    get_r_rights(state) {
      // return false
      return state.r_rights
    },
    get_cust_view(state) {
      return state.cust_view
      // return false
    },
    get_cust_rights(state) {
      // return false
      return state.cust_rights
    },
    get_sup_view(state) {
      return state.sup_view
      // return false
    },
    get_sup_rights(state) {
      // return false
      return state.sup_rights
    },
    get_invt_view(state) {
      return state.invt_view
      // return false
    },
    get_invt_rights(state) {
      // return false
      return state.invt_rights
    },
    get_stcktran_view(state) {
      return state.stcktran_view
      // return false
    },
    get_stcktran_rights(state) {
      // return false
      return state.stcktran_rights
    },
    get_prod_view(state) {
      return state.prod_view
      // return false
    },
    get_prod_rights(state) {
      // return false
      return state.prod_rights
    },
    get_cat_view(state) {
      return state.cat_view
      // return false
    },
    get_cat_rights(state) {
      // return false
      return state.cat_rights
    },
    get_brand_view(state) {
      return state.brand_view
      // return false
    },
    get_brand_rights(state) {
      // return false
      return state.brand_rights
    },
    get_tax_view(state) {
      return state.tax_view
      // return false
    },
    get_tax_rights(state) {
      // return false
      return state.tax_rights
    },
    get_hsn_view(state) {
      return state.hsn_view
      // return false
    },
    get_hsn_rights(state) {
      // return false
      return state.hsn_rights
    },
    get_var_view(state) {
      return state.var_view
      // return false
    },
    get_var_rights(state) {
      // return false
      return state.var_rights
    },
    get_unit_view(state) {
      return state.unit_view
      // return false
    },
    get_unit_rights(state) {
      // return false
      return state.unit_rights
    },
    get_pur_view(state) {
      // return false
      return state.pur_view
    },
    get_pur_rights(state) {
      // return false
      return state.pur_rights
    },
    get_purrt_view(state) {
      // return false
      return state.purrt_view
    },
    get_purrt_rights(state) {
      // return false
      return state.purrt_rights
    },
    get_sale_view(state) {
      // return false
      return state.sale_view
    },
    get_sale_rights(state) {
      // return false
      return state.sale_rights
    },
    get_salert_view(state) {
      // return false
      return state.salert_view
    },
    get_salert_rights(state) {
      // return false
      return state.salert_rights
    },
    get_salerechis_view(state) {
      return state.salerechis_view
    },
    get_salerechis_rights(state) {
      // return false
      return state.salerechis_rights
    },
    get_salereturnpay_view(state) {
      return state.salereturnpay_view
    },
    get_salerechis_rights(state) {
      return state.salereturnpay_rights
    },
    get_saleinvoice_view(state) {
      return state.saleinvoice_view
    },
    get_saleinvoice_rights(state) {
      return state.saleinvoice_rights
    },
    get_salerec_view(state) {
      return state.salerec_view
    },
    get_salerec_rights(state) {
      return state.salerec_rights
    },
    get_purpay_view(state) {
      return state.purpay_view
    },
    get_purpay_rights(state) {
      return state.purpay_rights
    },
    get_purpayhis_view(state) {
      return state.purpayhis_view
    },
    get_purpayhis_rights(state) {
      return state.purpayhis_rights
    },
    get_shopmodal(state) {
      return state.shopmodal
    },
    get_purchasereturnpay_view(state) {
      return state.purchasereturnpay_view
    },
    get_purchasereturnpay_rights(state) {
      return state.purchasereturnpay_rights
    },
    get_custmodal(state) {
      return state.custmodal
    },
    get_productmodal(state) {
      return state.productmodal
    },
    get_supmodal(state) {
      return state.supmodal
    },
  },
  mutations: {
    set_shop_user(state, shopuser) {
      state.is_shop_user = shopuser
    },
    set_super_user(state, superuser) {
      state.is_super_user = superuser
    },
    set_dashbd_view(state, dashbdview) {
      state.dashbd_view = dashbdview
    },
    set_dashbd_rights(state, dashbdright) {
      state.dashbd_rights = dashbdright
    },
    set_reg_view(state, regview) {
      state.reg_view = regview
    },
    set_reg_rights(state, regright) {
      state.reg_rights = regright
    },
    set_shop_view(state, shopview) {
      state.shop_view = shopview
    },
    set_shop_rights(state, shopright) {
      state.shop_rights = shopright
    },
    set_u_view(state, userview) {
      state.u_view = userview
    },
    set_u_rights(state, userright) {
      state.u_rights = userright
    },
    set_r_view(state, roleview) {
      state.r_view = roleview
    },
    set_r_rights(state, roleright) {
      state.r_rights = roleright
    },
    set_cust_view(state, custview) {
      state.cust_view = custview
    },
    set_cust_rights(state, custright) {
      state.cust_rights = custright
    },
    set_sup_view(state, supview) {
      state.sup_view = supview
    },
    set_sup_rights(state, supright) {
      state.sup_rights = supright
    },
    set_invt_view(state, invtview) {
      state.invt_view = invtview
    },
    set_invt_rights(state, invtright) {
      state.invt_rights = invtright
    },
    set_stcktran_view(state, stcktranview) {
      state.stcktran_view = stcktranview
    },
    set_stcktran_rights(state, stcktranright) {
      state.stcktran_rights = stcktranright
    },
    set_prod_view(state, prodview) {
      state.prod_view = prodview
    },
    set_prod_rights(state, prodright) {
      state.prod_rights = prodright
    },
    set_cat_view(state, catview) {
      state.cat_view = catview
    },
    set_cat_rights(state, catright) {
      state.cat_rights = catright
    },
    set_brand_view(state, brandview) {
      state.brand_view = brandview
    },
    set_brand_rights(state, brandright) {
      state.brand_rights = brandright
    },
    set_tax_view(state, taxview) {
      state.tax_view = taxview
    },
    set_tax_rights(state, taxright) {
      state.tax_rights = taxright
    },
    set_hsn_view(state, hsnview) {
      state.hsn_view = hsnview
    },
    set_hsn_rights(state, hsnright) {
      state.hsn_rights = hsnright
    },
    set_var_view(state, varview) {
      state.var_view = varview
    },
    set_var_rights(state, varright) {
      state.var_rights = varright
    },
    set_unit_view(state, unitview) {
      state.unit_view = unitview
    },
    set_unit_rights(state, unitright) {
      state.unit_rights = unitright
    },
    set_pur_view(state, purview) {
      state.pur_view = purview
    },
    set_pur_rights(state, purright) {
      state.pur_rights = purright
    },
    set_purrt_view(state, purrtview) {
      state.purrt_view = purrtview
    },
    set_purrt_rights(state, purrtright) {
      state.purrt_rights = purrtright
    },
    set_sale_view(state, saleview) {
      state.sale_view = saleview
    },
    set_sale_rights(state, saleright) {
      state.sale_rights = saleright
    },
    set_salert_view(state, salertview) {
      state.salert_view = salertview
    },
    set_salert_rights(state, salertright) {
      state.salert_rights = salertright
    },
    set_salerechis_view(state, salerechisview) {
      state.salerechis_view = salerechisview
    },
    set_salerechis_rights(state, salerechisrights) {
      state.salerechis_rights = salerechisrights
    },
    set_salereturnpay_view(state, salereturnview) {
      state.salereturnpay_view = salereturnview
    },
    set_salereturnpay_rights(state, salereturnright) {
      state.salereturnpay_rights = salereturnright
    },
    set_salerec_view(state, salerecview) {
      state.salerec_view = salerecview
    },
    set_salerec_rights(state, salerecrights) {
      state.salerec_rights = salerecrights
    },
    set_saleinvoice_view(state, saleinvoiceview) {
      state.saleinvoice_view = saleinvoiceview
    },
    set_saleinvoice_rights(state, saleinvoicerights) {
      state.saleinvoice_rights = saleinvoicerights
    },
    set_purpay_view(state, purpayview) {
      state.purpay_view = purpayview
    },
    set_purpay_rights(state, purpayrights) {
      state.purpay_rights = purpayrights
    },
    set_purpayhis_view(state, purpayhisview) {
      state.purpayhis_view = purpayhisview
    },
    set_purpayhis_rights(state, purpayhisrights) {
      state.purpayhis_rights = purpayhisrights
    },
    set_purchasereturnpay_view(state, purchasereturnview) {
      state.purchasereturnpay_view = purchasereturnview
    },
    set_puchasereturnpay_rights(state, purchasereturnright) {
      state.purchasereturnpay_rights = purchasereturnright
    },
    set_shopmodal(state, shop) {
      state.shopmodal = shop
    },
    set_custmodal(state, cust) {
      state.custmodal = cust
    },
    set_productmodal(state, prod) {
      state.productmodal = prod
    },
    set_supmodal(state, sup) {
      state.supmodal = sup
    },
    set_is_admin(state, admin) {
      state.is_admin = admin
    },
  },
  // plugins: [
  //     createPersistedState({
  //       getState: (u_view) => Cookies.getJSON(u_view),
  //       setState: (u_view, u_view) => Cookies.set(u_view, u_view, { expires: 3, secure: true })
  //     })
  //   ],

  strict: debug
})


// WEBPACK FOOTER //
// ./src/store.js